module.exports = __webpack_public_path__ + "img/glive.be7e622.webp";